import { Stack, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export namespace ParkingaboOverlineList {
    export function Body({
        sx,
        children,
    }: {
        sx?: SxProps<Theme>;
        children: React.ReactNode;
    }) {
        return (
            <Stack
                component="ul"
                direction="column"
                spacing={2}
                sx={[
                    {
                        justifyContent: 'flex-start',
                        alignItems: 'stretch',
                        listStyleType: 'none',
                        margin: 0,
                        padding: 0,
                    },
                    ...(Array.isArray(sx) ? sx : [sx]),
                ]}
            >
                {children}
            </Stack>
        );
    }

    export function Item({
        label,
        children,
    }: {
        label: React.ReactNode;
        children: React.ReactNode;
    }) {
        return (
            <li>
                <Typography variant="overline" component="div">
                    {label}
                </Typography>
                <Typography
                    component="div"
                    sx={{
                        fontWeight: 'bold',
                    }}
                >
                    {children}
                </Typography>
            </li>
        );
    }
}
